import React, { Component } from "react";

export default class ModuleTile extends Component {
  render() {
    const { title, initialLink, isActive, hideTile, icon, image } = this.props;

    return (
      <li
        className={isActive ? "active" : ""}
        style={{
          display: hideTile ? "none" : "block",
        }}
      >
        <a
          href={initialLink}
          className="sideList"
          refresh={this.props.children ? "" : "true"}
        >
          {icon && <i className={icon} style={{ color: "white" }}></i>}
          {image && (
            <img
              src={image}
              alt=""
              width="20"
              height="20"
              style={{ marginRight: 5 }}
            />
          )}
          <span className="sideText">{title}</span>
        </a>
        {this.props.children && (
          <ul className="nav nav-second-level collapse">
            {this.props.children}
          </ul>
        )}
      </li>
    );
  }
}
